import styled from 'styled-components';

export const StyledSavedCardRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-bottom: 1px solid var(--Color-Set-horizontal-vertical-rule, #c4c4c4);
  width: 100%;

  &:last-child {
    border-bottom: 1px solid var(--Color-Set-horizontal-vertical-rule, #c4c4c4);
  }

  .wallet-saved-cards-section__card-number-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
